<template>
  <v-card class="text-center" style="border-radius: 25px;" outlined >
    <v-card-title class="py-1" :class="(test.participantStatus === 'WINNER')? 'winner-top' : (test.participantStatus === 'DISQUALIFIED')? 'disqualified-top' : 'abandoned-top'">
      <h3 style="width: 100%" class="text-center status">
        {{ $t(`status.${test.participantStatus}`) }} <v-icon class="ml-1 mt-n1 status" small>{{ getStatusIcon(test.participantStatus) }}</v-icon>
      </h3>
    </v-card-title>
    <v-card-text class="pa-5">
      <v-container fluid>
        <v-row>
          <v-col>
            <v-img :src="currentPreference.iconUrl" max-height="50" class="mb-5" position="center center" contain/>
            <h2>{{ $t('title', { market: currentPreference.title }) }}</h2>
            <h1>{{ test.fundingEvaluation.fundingVendor.name }}</h1>
            <p class="mt-3 mb-5">{{ $t('finishedAt', { date: formatDate(new Date(test.finishedAt)) }) }}</p>
            <v-btn class="btn-details px-7" @click="seeSummary">{{ $t('btnSeeSummary') }}</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "FinishedTest",
  props: {
    market: String,
    test: Object,
  },
  data() {
    return {
      preferences: [
        { market: 'Forex', iconUrl: 'https://swiset.com/wp-content/uploads/2021/09/Swiset-Forex-Simulation.svg', title: this.$t('forex.title'),description: this.$t('forex.description') },
        { market: 'Futures', iconUrl: 'https://swiset.com/wp-content/uploads/2021/09/Swiset-Futures-Simulation.svg', title: this.$t('futures.title'), description: this.$t('futures.description') },
      ],
      currentPreference: null,
      months: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getMonths();
      this.currentPreference = this.preferences.find((data) => data.market === this.market);
      //this.processPerformance();
    },
    getMonths() {
      this.months = [
        this.$t('months.jan'),
        this.$t('months.feb'),
        this.$t('months.mar'),
        this.$t('months.apr'),
        this.$t('months.may'),
        this.$t('months.jun'),
        this.$t('months.jul'),
        this.$t('months.aug'),
        this.$t('months.sep'),
        this.$t('months.oct'),
        this.$t('months.nov'),
        this.$t('months.dec'),
      ];
    },
    processPerformance() {
      this.seriesBalance = [];
      let totalProfit = Math.abs(Number(this.test.fundingEvaluation.initialBalance) - Number(this.test.fundingEvaluation.target));
      let reachedProfit =  (Number(this.test.currentProfit) / totalProfit) * 100;
      this.seriesBalance.push(reachedProfit);
      this.stringDataBalance = {
        firstTitle: this.$t('targetTitle'),
        firstNumber: Number(this.test.fundingEvaluation.target) - Number(this.test.fundingEvaluation.initialBalance),
        secondTitle: this.$t('currentProfitTitle'),
        secondNumber: Number(this.test.currentProfit),
      };
    },
    getStatusIcon(status) {
      switch (status) {
        case 'WINNER':
          return 'fa-glass-cheers';
        case 'DISQUALIFIED':
          return 'fa-times';
        default:
          return 'fa-running';
      }
    },
    formatDate(date) {
      return `${date.getDate()} ${this.months[date.getMonth()]} / ${date.getFullYear()}`;
    },
    seeSummary() {
      this.$router.push({ name: 'funding-simulation-feedback', params: { testId: this.test.id, market: this.market }});
    }
  }
}
</script>

<i18n>
{
  "en": {
    "forex": {
      "title": "Forex"
    },
    "futures": {
      "title": "Futures"
    },
    "title": "Your simulation on {market}",
    "months": {
      "jan" : "Jan",
      "feb" : "Feb",
      "mar" : "Mar",
      "apr" : "Apr",
      "may" : "May",
      "jun" : "Jun",
      "jul" : "Jul",
      "aug" : "Aug",
      "sep" : "Sep",
      "oct" : "Oct",
      "nov" : "Nov",
      "dec" : "Dec"
    },
    "start": "Start",
    "end": "End",
    "daysRemaining": "{days} Remaining Days",
    "finishedAt": "Prueba terminada el día {date}",
    "status": {
      "WINNER": "WINNER!",
      "DISQUALIFIED": "DISQUALIFIED",
      "ABANDONED": "ABANDONED"
    },
    "btnSeeSummary": "See Summary"
  },
  "es": {
    "forex": {
      "title": "Forex"
    },
    "futures": {
      "title": "Futuros"
    },
    "title": "Tú simulación en {market}",
    "months": {
      "jan" : "Ene",
      "feb" : "Feb",
      "mar" : "Mar",
      "apr" : "Abr",
      "may" : "May",
      "jun" : "Jun",
      "jul" : "Jul",
      "aug" : "Aug",
      "sep" : "Sep",
      "oct" : "Oct",
      "nov" : "Nov",
      "dec" : "Dec"
    },
    "start": "Inicio",
    "end": "Final",
    "finishedAt": "Prueba terminada el día {date}",
    "status": {
      "WINNER": "¡GANADOR!",
      "DISQUALIFIED": "DESCALIFICADO",
      "ABANDONED": "ABANDONADO"
    },
    "btnSeeSummary": "Ver Resumen"
  }
}
</i18n>

<style lang="scss" scoped>
@import "src/global";
.btn-details {
  background-color: $black-color !important;
  color: $white-color !important;
}

.winner-top {
  background-color: $primary-color;
  .status {
    color: $text-color !important;
  }
}

.disqualified-top {
  background-color: $red-color;
  .status {
    color: $white-color !important;
  }
}

.abandoned-top {
  background-color: $secondary-color;
  .status {
    color: $text-color !important;
  }
}
</style>
